import { Box } from '@mui/material';
import { FC } from 'react';
import { Oval } from 'react-loader-spinner';

import styles from './Loader.module.scss';

interface LoaderProps {
	size: number;
}

const Loader: FC<LoaderProps> = ({ size, ...props }) => {
	return (
		<Box className={styles.wrapper}>
			<Oval
				height={size}
				width={size}
				visible
				ariaLabel="oval-loading"
				color="#fff"
				secondaryColor="#4786ff"
				strokeWidth={5}
				strokeWidthSecondary={5}
				{...props}
			/>
		</Box>
	);
};

export default Loader;
